import {
  NgClass,
  NgFor,
  NgIf,
  NgOptimizedImage,
  NgStyle,
} from '@angular/common';
import {
  Component,
  ElementRef,
  Input,
  OnChanges,
  OnInit,
  OnDestroy,
  QueryList,
  ViewChildren,
  AfterViewInit,
} from '@angular/core';
import { Product, ProductImage } from 'src/app/classes/utility';
import { EnvironmentService } from 'src/app/service/environment.service';
import { ProductService } from '../../product.service';

@Component({
  selector: 'app-image-gallery',
  imports: [NgOptimizedImage, NgFor, NgClass, NgStyle, NgIf],
  templateUrl: './image-gallery.component.html',
  styleUrl: './image-gallery.component.scss',
})
export class ImageGalleryComponent implements OnChanges, OnInit, OnDestroy, AfterViewInit {
  @Input() product!: Product;
  @ViewChildren('image') images!: QueryList<ElementRef>;

  _image!: ProductImage;
  _classes: any = [];
  _sleeve: any | undefined;
  window = this.environmentService.getWindow();
  private observer?: IntersectionObserver;
  constructor(
    private productService: ProductService,
    private environmentService: EnvironmentService
  ) {
    this.productService.sleeveObservable.subscribe((data) => {
      this._sleeve = data;
    });
  }

  ngOnInit(): void {
    this.productService.variantObservable.subscribe((data) => {
      const variantImage = this.product.images.find(
        (x) => x.id == data.image_id
      );
      if (variantImage) {
        this._image = variantImage;
        const imageIndex = this.product.images.indexOf(variantImage);
        if (imageIndex !== -1) {
          setTimeout(() => {
            this.scrollToImage(variantImage, imageIndex);
          }, 100);
        }
      }
    });
    this.setupIntersectionObserver();
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.observeImages();
    }, 100);
  }

  ngOnDestroy(): void {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  private setupIntersectionObserver(): void {
    if (!this.window) return;
    
    const options = {
      root: null,
      rootMargin: '-40% 0px -40% 0px',
      threshold: 0
    };

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const imageElement = entry.target;
          const index = parseInt(imageElement.getAttribute('data-index') || '0');
          if (this.product.images[index]) {
            this._image = this.product.images[index];
          }
        }
      });
    }, options);
  }

  private observeImages(): void {
    if (!this.observer || !this.images) return;
    
    this.images.forEach((imageRef, index) => {
      if (imageRef.nativeElement) {
        imageRef.nativeElement.setAttribute('data-index', index.toString());
        this.observer!.observe(imageRef.nativeElement);
      }
    });
  }

  scrollTo() {
    this.environmentService.getWindow()?.scrollTo();
  }

  scrollToImage(image: any, index: number) {
    this._image = image;
    const imageElement = this.images.toArray()[index]?.nativeElement;
    if (!imageElement) return;
    const rect = imageElement.getBoundingClientRect();
    const offsetTop = window.pageYOffset + rect.top + -100;
    window.scrollTo({
      top: offsetTop,
      behavior: 'smooth',
    });
  }

  ngOnChanges() {
    this._image = this.product.images[0];
    if (this.observer && this.images) {
      this.observer.disconnect();
      setTimeout(() => {
        this.observeImages();
      }, 100);
    }
  }
}
